/**
 * 队伍群聊面板：打开（惰性创建）队伍会话后挂 ChatRoom。
 * 仅 accepted 成员可用（后端校验；未入队时给出可见降级说明）。
 */
import { useQuery } from '@tanstack/react-query';

import { chatApi } from '../api/chat.js';
import { ChatRoom } from './ChatRoom.js';
import { ErrorState } from './ErrorState.js';
import { Loading } from './Loading.js';

export function TeamChatPanel({ teamId, teamName }: { teamId: string; teamName: string }) {
  const conversationQuery = useQuery({
    queryKey: ['chat', 'team-conv', teamId],
    queryFn: () => chatApi.openTeam(teamId),
    // 会话 id 不会变，开一次即可；失败可重试
    staleTime: 5 * 60_000,
    retry: 1,
  });

  if (conversationQuery.isPending) return <Loading label="打开队伍群聊中" />;
  if (conversationQuery.isError) {
    return (
      <ErrorState
        error={conversationQuery.error}
        title="无法打开队伍群聊"
        onRetry={() => void conversationQuery.refetch()}
      />
    );
  }
  const conversation = conversationQuery.data.conversation;
  return (
    <ChatRoom
      conversationId={conversation.id}
      title={`${teamName} · 队伍群聊`}
      subtitle="仅队伍成员可见；3 秒自动刷新"
    />
  );
}
